import { IconMapMetroMsk16, IconMapMetroSpb16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IIconsMetro {
  type?: string;
  color?: string;
}

export const IconsMetro: React.FC<React.PropsWithChildren<IIconsMetro>> = ({ type, color }) => {
  switch (type) {
    case 'spb':
      return (
        <div style={{ color, display: 'flex' }}>
          <IconMapMetroSpb16 color="current_color" />
        </div>
      );

    default:
      return (
        <div style={{ color, display: 'flex' }}>
          <IconMapMetroMsk16 color="current_color" />
        </div>
      );
  }
};

IconsMetro.displayName = 'IconsMetro';
